export const experienceData = [
    {
        id: 1,
        company: 'Estonian Aviation Academy',
        jobtitle: 'Student',
        startYear: '2025 September',
        endYear: 'present'
    },
    {
        id: 2,
        company: 'Olympic Entertainment Group',
        jobtitle: 'Machine Technician',
        startYear: '2024 September',
        endYear: '2025 September'
    },
    {
        id: 3,
        company: 'Ampler Bikes',
        jobtitle: 'Assembly Technician',
        startYear: '2021 October',
        endYear: '2023'
    },
    
]
